"use strict";

moment.locale(languageCode);